import { CloseOutlined } from '@mui/icons-material'
import { Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useState } from 'react'
import CustomTable from '../../customTable'
import _ from 'lodash'
import { useStyle } from '../style'

const ProductReport = ({setActiveStep,setOpen,dateData}) => {
    const classes = useStyle()
    const [page, setPage] = useState(0);
    const pageOption = [10, 25, 50, 100];
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    // const [data, setData] = useState(dateData)
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "productName",
            headerName: "Product Name",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
    ]
    const handlClose = () => {
       setOpen(false)
       setActiveStep("0") 
    }
// const rows = []
    // const rows = _.map(data , (val ) => _.map(val.sales_lines , (value , idx ) => ({
    //     id: idx,
    //     sno: idx+1,
    //     productName:value.pro_name
    // })))
    // const props = {
    //     columns : columns,
    //     rows : rows,
    //     page: page,
    //     setPage: setPage,
    //     rowsPerPage: rowsPerPage,
    //     setRowsPerPage: setRowsPerPage,
    //     pageCount: pageCount,
    //     pageOption: pageOption,
    //   }
      console.log(dateData)
      let totalAmt=0
      totalAmt += dateData.reduce((accumulator, item) => accumulator + parseFloat(item.rate * item.qty), 0);
  
      let gstAmt=0
      gstAmt += dateData.reduce((accumulator, item) => accumulator + parseFloat(item.gst_amt), 0);
      let cessAmt=0
      cessAmt += dateData.reduce((accumulator, item) => accumulator + parseFloat(item.cess_amt), 0);
    let netTotal = 0
    // netTotal = parseFloat(totalAmt + gstAmt + cessAmt).toFixed(0)
    netTotal = parseFloat(totalAmt + gstAmt ).toFixed(0)

console.log(netTotal, cessAmt, gstAmt,'Enna varuthu')
    //   console.log(_.map(dateData.data,(val) =>_.map(val.sales_lines , (value) => value.category_name)))
    return (
    <Grid>
    <Grid sx={{display:"flex" , justifyContent:"space-between",padding:2,alignItems:"center"}}>
        <Button onClick={() => setActiveStep("1")} variant="contained">Back</Button>
        <Typography variant='h6'>Products reports</Typography>
       
        <IconButton onClick={handlClose}>
            <CloseOutlined />
        </IconButton>
    </Grid>
    <Grid >
        <TableContainer className={classes.tblRoot} >
            <Table className={classes.table}>
                <TableHead className={classes.tblHeader} sx={{backgroundColor:"#A06EE1",color:"#fff"}}>
                    <TableRow className={classes.tablrow} sx={{color:"#fff"}}>
                    <TableCell className={classes.tblCell} sx={{color:"#fff"}}>S.No</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Bill No</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Product Name</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Rate</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Quantity</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>GST Amnt</TableCell>
                        {/* <TableCell className={classes.tblCell} sx={{color:"#fff"}}>CESS Amnt</TableCell> */}
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {
                    _.map(dateData , (value , idx ) => (
                            <TableRow className={classes.tablrow} key={idx}>
                                <TableCell>{idx + 1}</TableCell>
                                <TableCell>{value.docno}</TableCell>
                                <TableCell>{value.pro_name}</TableCell>
                                <TableCell sx={{fontWeight:600,textAlign:"right !important"}}>{parseFloat(value.rate).toFixed(0)}</TableCell>
                                <TableCell>{value.qty}</TableCell>
                                <TableCell>{parseFloat(value.gst_amt).toFixed(0)}</TableCell>
                                {/* <TableCell>{value.cess_amt}</TableCell> */}
                                <TableCell sx={{fontWeight:600,textAlign:"right !important"}}>{parseFloat(value.rate * value.qty).toFixed(0)}</TableCell>
                            </TableRow>
                    ))
                }
                </TableBody>
            </Table>
        </TableContainer>
    <Grid   sx={{padding:"10px",border:"1px solid #ccc"}}>
        <Typography fontWeight={600} fontSize={20} textAlign='right' sx={{textAlign:'right !important'}}>Total : {parseFloat(netTotal).toFixed(0)}</Typography>
    </Grid>

    </Grid>
   
</Grid>
  )
}

export default ProductReport